import { CoverageChecker } from './coverage-checker'

export default CoverageChecker
